import axios from "../../../context/axiosConfig";
import { useState, useEffect } from "react";
import { usePaginationPrzekazy } from "../../../context/PaginationContextPrzekazy";

const PrzekazyGetList = () => {
	const { pagination, setPagination } = usePaginationPrzekazy();
	const [data, setData] = useState([]);

	useEffect(() => {
		setPagination({ ...pagination, loading: true });
		const fetchData = async () => {
			const response = await axios.post("/przekazania/get/list", {
				pagination: pagination,
			});
			if (
				pagination.current >
				response.data.total / pagination.pagesize
			) {
				setPagination({ ...pagination, current: 1 });
			}
			setPagination({ ...pagination, loading: false });
			setData(response.data);
		};
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		pagination.current,
		pagination.pagesize,
		pagination.reload,
		pagination.generated,
		pagination.search,
	]);

	return data;
};

export default PrzekazyGetList;
